<section class="denial-reasons-section">
    <div class="denial-reasons-header">
        <h1 class="module-heading">
            {{ 'pages.config-all.denial-reasons.heading' | translate }} — {{ sectionLabel }}
            <div class="loading-spinner" *ngIf="saving">
                <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
            </div>
        </h1>
        <button class="bciti-button bciti-button--blue-inversed" (click)="openAddDialog()">
            + {{ 'pages.config-all.denial-reasons.addButton' | translate }}
        </button>
    </div>

    <div class="lang-tabs" *ngIf="langs?.length > 1 && dataSource.data.length > 0">
        <button
            *ngFor="let lang of langs"
            class="lang-tab"
            [class.active]="selectedLang === lang"
            (click)="switchLang(lang)"
        >
            {{ 'pages.config-all.denial-reasons.langs.' + lang | translate }}
        </button>
    </div>

    <div class="denial-reasons-table-wrapper" *ngIf="dataSource.data.length > 0">
        <table
            mat-table
            [dataSource]="dataSource"
            cdkDropList
            [cdkDropListData]="dataSource.data"
            (cdkDropListDropped)="drop($event)"
        >
            <!-- Drag Handle -->
            <ng-container matColumnDef="dragHandle">
                <th class="table-header drag-header" mat-header-cell *matHeaderCellDef></th>
                <td class="drag-cell" mat-cell *matCellDef="let element">
                    <span class="drag-handle">⠿</span>
                </td>
            </ng-container>

            <!-- Title -->
            <ng-container matColumnDef="title">
                <th class="table-header" mat-header-cell *matHeaderCellDef>
                    {{ getHeader('title') }}
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.title }}
                </td>
            </ng-container>

            <!-- Description Interne -->
            <ng-container matColumnDef="internalDescription">
                <th class="table-header" mat-header-cell *matHeaderCellDef>
                    {{ getHeader('internalDescription') }}
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.internalDescription }}
                </td>
            </ng-container>

            <!-- Motif Citoyen -->
            <ng-container matColumnDef="citizenReason">
                <th class="table-header" mat-header-cell *matHeaderCellDef>
                    {{ getHeader('citizenReason') }}
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.citizenReason }}
                </td>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="actions">
                <th class="table-header" mat-header-cell *matHeaderCellDef>
                    {{ getHeader('actions') }}
                </th>
                <td mat-cell *matCellDef="let element" class="actions-cell">
                    <div class="actions-row">
                        <button
                            class="bciti-button bciti-button--invisible action-btn"
                            (click)="openEditDialog(element)"
                            [disabled]="saving"
                        >
                            <i class="icon-edit"></i>
                        </button>
                        <button
                            class="bciti-button bciti-button--invisible action-btn"
                            (click)="openDeleteDialog(element)"
                            [disabled]="saving"
                        >
                            <i class="icon-trash-bin"></i>
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                cdkDrag
                cdkDragLockAxis="y"
                [cdkDragData]="row"
                class="grabbable"
            ></tr>

            <div *cdkDragPlaceholder></div>
        </table>
    </div>
</section>
